import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddTaskComponent } from './add-task/add-task.component';
import { CreateTaskComponent } from './create-task/create-task.component';
import { EditTaskComponent } from './edit-task/edit-task.component';
import { MysprintsComponent } from './mysprints/mysprints.component';
import { MytasksComponent } from './mytasks/mytasks.component';
import { SprintDetailsComponent } from './sprint-details/sprint-details.component';
import { TaskDetailsComponent } from './task-details/task-details.component';

const routes: Routes = [
  { path: '', redirectTo: '/current', pathMatch: 'full' },
  { path: 'add', redirectTo: 'add/backlog', pathMatch: 'full' },
  { path: 'add/:mode', component: AddTaskComponent },
  { path: 'create-task', component: CreateTaskComponent },
  { path: 'current', component: MytasksComponent },
  { path: 'edit-task/:taskId', component: EditTaskComponent },
  { path: 'sprints', component: MysprintsComponent },
  { path: 'sprint/:sprintId', component: SprintDetailsComponent },
  { path: 'task/:taskId', component: TaskDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
